import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLock, FiAlertTriangle, FiSlash } = FiIcons;

const Login = () => {
  const { login } = useAuth();
  const [isConnecting, setIsConnecting] = useState(false);

  const params = new URLSearchParams(window.location.hash.split('?')[1] || '');
  const errorParam = params.get('error');

  const handleLogin = () => {
    setIsConnecting(true);
    login();
  };

  const renderError = () => {
    if (errorParam === 'blocked') {
      return (
        <div className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4 flex gap-3">
          <SafeIcon icon={FiSlash} className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-red-700">
            It is not possible to access the blog right now. Please speak with your manager.
          </p>
        </div>
      );
    }
    if (errorParam === 'unauthorised') {
      return (
        <div className="mb-6 bg-amber-50 border border-amber-200 rounded-lg p-4 flex gap-3">
          <SafeIcon icon={FiAlertTriangle} className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-amber-700">
            Only allocated staff can write new blogs. If you would like to contribute to the blog, please speak with your manager.
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
           <div className="w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg" style={{ backgroundColor: 'var(--brand-primary)' }}>
             <span className="text-white font-bold text-3xl">HL</span>
           </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Admin Sign In
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Restricted access for Haringey Learns staff only
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 border border-gray-100">
          {renderError()}
          <div className="space-y-6">
            <div>
              <button
                onClick={handleLogin}
                disabled={isConnecting || errorParam === 'blocked'}
                className={`w-full flex justify-center items-center gap-3 py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#0078D4] hover:bg-[#106EBE] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0078D4] transition-colors ${(isConnecting || errorParam === 'blocked') ? 'opacity-75 cursor-not-allowed' : ''}`}
              >
                <svg className="w-5 h-5" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#f35325" d="M0 0h10v10H0z"/>
                  <path fill="#81bc06" d="M11 0h10v10H11z"/>
                  <path fill="#05a6f0" d="M0 11h10v10H0z"/>
                  <path fill="#ffba08" d="M11 11h10v10H11z"/>
                </svg>
                {isConnecting ? 'Connecting to Entra ID...' : 'Sign in with Microsoft'}
              </button>
            </div>
            
            <div className="mt-6">
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-300" />
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-white text-gray-500 flex items-center gap-2">
                    <SafeIcon icon={FiLock} className="w-4 h-4" /> Secure SSO Login
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;